import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Tag, Tooltip} from 'antd'
import {InfoCircleOutlined} from '@ant-design/icons'

const MAX_CHIPS = 6

class IncompleteOrdersWarning extends Component {
    // null = người dùng chưa bấm gì -> tự quyết theo độ dài danh sách hiện tại.
    // KHÔNG khởi tạo từ this.props.orders: component mount trước khi items API trả về
    // (orders vẫn là []) nên giá trị sẽ bị chốt thành true vĩnh viễn.
    state = {
        expanded: null
    }

    // Mở sẵn bảng chi tiết khi danh sách ngắn (ca phổ biến nhất) để không mất thêm cú click
    _isExpandedFBA = () => {
        const {expanded} = this.state

        if (expanded !== null) return expanded

        return this.props.orders.length <= 3
    }

    _handleToggle = (e) => {
        e.preventDefault()

        const expanded = this._isExpandedFBA()

        this.setState({
            expanded: !expanded
        })
    }

    render() {
        const {orders, hint, alertText} = this.props

        // Điều kiện hiện cảnh báo CHỈ dựa vào dữ liệu, không kiểm tra box.status
        // → thùng đã đóng/đã ship vẫn thấy để tra soát
        if (!orders.length) return null

        const expanded = this._isExpandedFBA()
        const totalUnpacked = orders.reduce((sum, order) => sum + order.unpacked, 0)
        const chips = orders.slice(0, MAX_CHIPS)
        const restCount = orders.length - chips.length

        return (
            <Alert
                className="IncompleteOrdersWarning"
                type="error"
                showIcon
                closable={false}
                message={
                    <span className="summary">
                        Còn <strong>{orders.length} đơn</strong> chưa đóng đủ
                        {' — '}<strong>{totalUnpacked} sản phẩm</strong> chưa tích vào thùng nào.
                        {/* alertText hiện thẳng (không tooltip) cho những trạng thái mà cảnh báo
                            này là kênh thông tin DUY NHẤT — cụ thể là thùng đã chốt/đã ship:
                            CloseBox return null nên không còn nút, không tooltip nút, không modal.
                            Ẩn sau icon ở state đó sẽ làm mất tác dụng tra soát (GAP-03). */}
                        {!!alertText && <> <strong className="alertText">{alertText}</strong></>}
                        {/* Câu nhắc theo role đưa vào tooltip để dòng tóm tắt ngắn gọn.
                            trigger phải khai báo tay: antd 4.5.4 không set `trigger` trong
                            defaultProps nên rơi về ['hover'] của rc-tooltip -> trạm đóng gói
                            dùng màn hình cảm ứng sẽ không mở được tooltip.
                            <span> để gắn tabIndex (icon focus được bằng bàn phím) + spacing;
                            về mặt ref thì không bắt buộc vì icon antd tự forwardRef. */}
                        {!!hint && (
                            <Tooltip title={hint} trigger={['hover', 'click', 'focus']}>
                                <span className="hintIcon" tabIndex={0}>
                                    <InfoCircleOutlined/>
                                </span>
                            </Tooltip>
                        )}
                    </span>
                }
                description={
                    <div className="detail">
                        <div className="chips d-flex flex-wrap align-items-center">
                            {chips.map(order => (
                                <Tag color="red" key={order.barcodeNumber}>
                                    #{order.barcodeNumber} thiếu {order.unpacked}/{order.itemCount}
                                </Tag>
                            ))}

                            {restCount > 0 && <span className="rest">+{restCount} đơn khác</span>}

                            {/* toggle nằm trong description vì antd 4.5.4 chưa có prop `action` */}
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="#" className="toggle ml-auto" onClick={this._handleToggle}>
                                {expanded ? 'Ẩn chi tiết ▴' : `Xem chi tiết (${orders.length} đơn) ▾`}
                            </a>
                        </div>

                        {expanded && (
                            // Thùng FBA thường có rất nhiều item nên danh sách đơn thiếu
                            // có thể dài -> giới hạn chiều cao và cho scroll, header dính
                            // lại ở trên để không mất tên cột khi cuộn
                            <div className="tableWrap">
                                {/* không dùng table-sm: padding của nó bị table-compact ghi đè hoàn toàn */}
                                <table className="table table-compact mb-0">
                                    <thead>
                                    <tr>
                                        <th>Barcode</th>
                                        <th className='text-center'>Tổng SP</th>
                                        <th className='text-center'>Trong thùng này</th>
                                        <th className='text-center'>Chưa đóng</th>
                                        <th>Đã đóng</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {orders.map(order => {
                                        const {barcodeNumber, itemCount, itemInBox, unpacked, packed} = order
                                        const percent = itemCount > 0
                                            ? Math.round((packed / itemCount) * 100)
                                            : 0

                                        return (
                                            <tr key={barcodeNumber}>
                                                <td><strong>#{barcodeNumber}</strong></td>
                                                <td className='text-center'>{itemCount}</td>
                                                <td className='text-center'>{itemInBox}</td>
                                                <td className="unpacked text-center">{unpacked}</td>
                                                {/* gộp tiến độ thành text thay vì progress bar để bảng gọn chiều ngang */}
                                                <td className="packed">{packed}/{itemCount} ({percent}%)</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                }
            />
        )
    }
}

IncompleteOrdersWarning.propTypes = {
    orders: PropTypes.array.isRequired,
    hint: PropTypes.string,
    alertText: PropTypes.string,
}

// Mặc định rỗng: consumer không truyền thì render y như trước
IncompleteOrdersWarning.defaultProps = {
    hint: '',
    alertText: '',
}

export default IncompleteOrdersWarning
